<div class="layout" [class.layout--article]="layoutService.getIsArticle()">
    @if (headerViewService.options$ | async; as bannerOptions) {
        <div id="layout__top-banner">
            @if (bannerOptions.exists) {
                <website-top-banner
                    class="layout__top-banner"
                    [text]="bannerOptions.text"
                    [icon]="bannerOptions.icon"
                    [hasIcon]="bannerOptions.hasIcon"
                    [hasCloseButton]="bannerOptions.hasCloseButton"
                    [colorScheme]="bannerOptions.colorScheme"
                >
                </website-top-banner>
            }
        </div>
    }

    <div class="layout__header" [class.layout__header--static]="(headerService.state$ | async)?.disableStickiness">
        @if (layoutService.shouldRenderHeader()) {
            <app-rebranded-header></app-rebranded-header>
        }
    </div>

    <main class="layout__content view">
        <router-outlet></router-outlet>
    </main>

    <ng-container #footerSecondaryContainer></ng-container>

    <div class="layout__footer">
        <ng-container #footerContainer></ng-container>
    </div>

    @if (headerViewService.pinnedCtaOptions$ | async; as pinnedCtaData) {
        <div class="layout__pinned-cta">
            @if (pinnedCtaData.exists) {
                <app-pinned-cta [pinnedCtaData]="pinnedCtaData"></app-pinned-cta>
            }
        </div>
    }
</div>
